// Crypto Treenvest Base Styles
import borders from "assets/theme/base/borders";

// Crypto Treenvest Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;

const accordionDetails = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.xl,
      margin: `${pxToRem(16)}`,
      marginTop: pxToRem(-16),
      padding: 0,
    },

    media: {
      width: "auto",
    },
  },
};

export default accordionDetails;
